import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FilterList from '@material-ui/icons/FilterList';
import { Box, InputLabel } from '@material-ui/core';
import { WrapWithToolTip } from 'utils/toolTipWrapper';
import { translateValue } from 'utils/methods/helpers';
import PropTypes from 'prop-types';

const toggleFilterTypes = 'AdvancedFilters';

const WithRotateFilterList = withStyles(() => ({
  root: {
    transform: 'rotate(180deg)',
    height: '2rem',
    width: '2rem',
  },
}))(FilterList);
const WithoutRotateFilterList = withStyles(() => ({
  root: {
    height: '2rem',
    width: '2rem',
  },
}))(FilterList);

const InputLabelStyled = withStyles(() => ({
  root: {
    inlineSize: '30px',
    wordBreak: 'break-all',
  },
}))(InputLabel);

const FilterTypeList = ({ handleChange, hoverText = 'Toggle Filters' }) => {
  const [advanceFilterState, setAdvanceFilterState] = React.useState({
    AdvancedFilters: false,
  });

  const handleClick = event => {
    setAdvanceFilterState(prev => ({ ...prev, ...event }));
    handleChange(event);
  };

  return (
    <WrapWithToolTip hoverText={hoverText}>
      <Box display={'flex'} flexDirection={'column'}>
        <InputLabelStyled
          shrink={true}
          htmlFor={'More'}
          focused={false}
          style={{}}
        >
          {translateValue('More')}
        </InputLabelStyled>
        <Box
          component={'div'}
          onClick={() =>
            handleClick({
              [toggleFilterTypes]: !advanceFilterState.AdvancedFilters,
            })
          }
        >
          {!advanceFilterState.AdvancedFilters ? (
            <WithoutRotateFilterList />
          ) : (
            <WithRotateFilterList />
          )}
        </Box>
      </Box>
    </WrapWithToolTip>
  );
};
FilterTypeList.propTypes = {
  handleChange: PropTypes.func,
  hoverText: PropTypes.string,
};
export default FilterTypeList;
